import { Injectable } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';

import { Carrier, CarrierTypes } from '@app/services/carriers/carrier.model';
import { Shop } from '@app/services/shops/shop.model';
import { CarriersActions } from '../actions';
import { CarriersService } from '../../services/carriers.service';

@Injectable()
export class CarriersEffects {
  constructor(
    private actions$: Actions,
    private carriersService: CarriersService,
  ) {}

  loadShopsUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CarriersActions.loadShopsUser),
      switchMap(() => {
        return this.carriersService.loadShopsUser().pipe(
          map((shopsList: Shop[]) => {
            return CarriersActions.loadShopsUserSuccess({ shopsList });
          }),
          catchError(() => {
            return of(CarriersActions.loadShopsUserFailure());
          }),
        );
      }),
    ),
  );

  loadAllCarrierTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CarriersActions.loadAllCarrierTypes),
      switchMap(() => {
        return this.carriersService.loadAllCarrierTypes().pipe(
          map((carrierTypes: CarrierTypes[]) => {
            return CarriersActions.loadAllCarrierTypesSuccess({ carrierTypes });
          }),
          catchError(() => {
            return of(CarriersActions.loadAllCarrierTypesFailure());
          }),
        );
      }),
    ),
  );

  loadCarriersByShop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CarriersActions.loadCarriersByShop),
      switchMap(({ shopID }) => {
        return this.carriersService.loadCarriersByShop().pipe(
          map((carriers: Carrier[]) => {
            return CarriersActions.loadCarriersByShopSuccess({ carriers });
          }),
          catchError(() => {
            return of(CarriersActions.loadCarriersByShopFailure());
          }),
        );
      }),
    ),
  );

  // loadCarrierByID$ = createEffect(
  //   () => this.actions$.pipe(
  //     ofType(CarriersActions.loadCarrierByID),
  //     switchMap(({ carrierID }) => {
  //       return this.carriersService.loadCarrierByID(carrierID).pipe(
  //         map(() => {
  //           return CarriersActions.loadCarrierByIDSuccess();
  //         }),
  //         catchError(() => {
  //           return of(CarriersActions.loadCarrierByIDFailure());
  //         })
  //       );
  //     })
  //   )
  // );

  addNewCarrier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CarriersActions.addNewCarrier),
      switchMap(({ carrier, shopID }) => {
        return this.carriersService.addNewCarrier(carrier, shopID).pipe(
          map((response) => {
            return CarriersActions.addNewCarrierSuccess({
              carrier: response.carrier,
              requiresVerification: response.requiresVerification,
            });
          }),
          catchError((error) => {
            return of(
              CarriersActions.addNewCarrierFailure({
                errorMessage: error,
              }),
            );
          }),
        );
      }),
    ),
  );

  deleteCarrier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CarriersActions.deleteCarrier),
      switchMap(({ carrierId, shopId }) => {
        return this.carriersService.deleteCarrier(carrierId, shopId).pipe(
          map(() => {
            CarriersActions.loadCarriersByShop({ shopID: shopId });
            return CarriersActions.deleteCarrierSuccess({ carrierId });
          }),
          catchError((error) => {
            return of(
              CarriersActions.deleteCarrierFailure({
                errorMessage: error,
              }),
            );
          }),
        );
      }),
    ),
  );

  editCarrier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CarriersActions.editCarrier),
      switchMap(({ carrier, shopID, metadata }) => {
        return this.carriersService.editCarrier(carrier, shopID).pipe(
          map((response) => {
            return CarriersActions.editCarrierSuccess({
              carrier: response.carrier,
              metadata,
              requiresVerification: response.requiresVerification,
            });
          }),
          catchError((error) => {
            return of(CarriersActions.editCarrierFailure({ errorMessage: error?.error || error }));
          }),
        );
      }),
    ),
  );
}
